<div class="trainingRequirements">
<p-dialog
    header="Training Plan Review History"
    [(visible)]="isTrainingPlanReviewHistoryModelOpen"
    [modal]="true"
    [draggable]="false"
    (onHide)="onDialogHide()"
    [style]="{ width: '75vw', 'margin-left': '1em' }"
  >
    <app-panel-list
      [panelList]="trainingPlanReviewListInput"
      [noResultFound]="noData"
    >
      <ng-template #templateRef let-data="dataVar">
        <div panel-content class="grid">
          <div class="col-fixed text-left" style="width: 12%">
            <div class="font-semibold mb-1">Due Date</div>
            <div class="content-wrap">
              {{ data?.dueDate | date : "dd-MMM-yyyy" }}
            </div>
          </div>
          <div class="col-fixed" style="width: 12%">
            <div class="font-semibold mb-1">Status</div>
            <div class="content-wrap">
              <em
                class="pi pi-circle-fill"
                [ngClass]="getStatusClass(data?.status)"
              ></em>
              {{ data?.status }}
            </div>
          </div>
          <div class="col-fixed text-left" style="width: 12%">
            <div class="font-semibold mb-1">Review Date</div>
            <div class="content-wrap">
              {{ data?.reviewDate | date : "dd-MMM-yyyy" }}
            </div>
          </div>
          <div class="col-fixed text-left" style="width: 28%">
            <div class="font-semibold mb-1">Review By</div>
            <div class="eSignature">
            <div class="content-wrap">
              {{ data?.reviewBy }}
            </div>
            <i
              *ngIf="
                data?.reviewBy !== null &&
                data?.reviewBy !== 'NaN' &&
                data?.reviewBy !== 'undefined'
              "
              class="fa-solid fa-file-signature ml-2 blue-color cursor-pointer"
              pTooltip="eSignature"
              (click)="openESignature(data)"
            ></i>
          </div>
          </div>
          <div class="col-fixed text-left" style="width: 35%">
            <div class="font-semibold mb-1">Review Comment</div>
            <div class="content-wrap">
              {{ data?.reviewComment }}
            </div>
          </div>
        </div>
      </ng-template>
    </app-panel-list>
  </p-dialog> 

 <!-- Modal for ESignature -->
 <p-dialog
 header="eSignature"
 [(visible)]="isESignatureModalOpen"
 [modal]="true"
 [draggable]="false"
 [style]="{ width: '35vw', 'margin-left': '1em' }"
>
 <div panel-content class="grid">
   <div class="col-fixed text-left content-padding" style="width: 100%">
     <div class="font-semibold mb-1">User</div>
     <div class="content-wrap">
       {{ eSignatureInfo.esignature }}
     </div>
     <div></div>
     <br />
     <div class="font-semibold mb-1">Date & Time</div>
     <div class="content-wrap">
       {{
         eSignatureInfo.esignatureDateTime
           | date : "dd-MMM-yyyy HH:mm" : "UTC"
       }}
       {{ timeZoneFormat }}
     </div>
     <div></div>
     <br />
     <div class="font-semibold mb-1">Meaning</div>
     <div class="content-wrap">
       {{ eSignatureInfo.esignatureMeaning }}
     </div>
   </div>
 </div>
</p-dialog>

</div>